module.exports = __webpack_public_path__ + "img/healthExamination.810bc210.png";